<template>
  <img src="~@/assets/imgs/arrow.png" alt="-->" />
</template>

<script>
export default {
  name: 'Button',
};
</script>

<style scoped></style>
